import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgZorroAntdModule } from 'ng-zorro-antd';
import { HdButtonGroupModule } from '../hd-button-group/hd-button-group.module';
import { HdButtonModule } from '../hd-button/hd-button.module';
import { HdSpaceModule } from '../hd-space/hd-space.module';
import { CommonSessionService } from '../service/common-session.service';
import { HdFormLinesComponent } from './hd-form-lines.component';
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgZorroAntdModule,
    HdButtonModule,
    HdSpaceModule,
    HdButtonGroupModule
  ],
  declarations: [HdFormLinesComponent],
  exports: [HdFormLinesComponent],
  providers: [CommonSessionService]
})
export class HdFormLinesModule { }
